<template>
  <div class="rounded bg-grey_3 pa-3 mb-4 bordered">
    <div class="text-h5 mb-4 font-weight-bold">
      {{ option.nom }}
      <v-chip color="primary-dark" variant="elevated" elevation="0" density="compact">{{ option.nb_inscrits }}
        inscrits</v-chip>
    </div>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field v-model="option.nom" label="Nom de l'option"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field v-model="option.prix" type="number" label="Prix"
          append-inner-icon="mdi-currency-eur"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <v-switch v-model="option.obligatoire" hide-details true-value="1" false-value="0"
          :label="option.obligatoire == '1' ? 'Option obligatoire' : 'Option facultative'" color="green"
          inset></v-switch>
      </v-col>
      <v-col cols="12" md="4">
        <v-switch v-model="option.visible_accueil" hide-details true-value="1" false-value="0"
          :label="option.visible_accueil == '1' ? 'Visible sur l\'accueil' : 'Masquée sur l\'accueil'" color="green"
          inset></v-switch>
      </v-col>
      <v-col cols="12" md="4">
        <v-switch v-model="option.disponible_changement" hide-details true-value="1" false-value="0"
          :label="option.disponible_changement == '1' ? 'Disponible en ajout d\'option' : 'Non disponible en ajout d\'option'"
          color="green" inset></v-switch>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3">
        <v-text-field v-model="option.date_min" type="date" label="Date d'ouverture"></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field v-model="option.heure_min" type="time" label="Heure d'ouverture"></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field v-model="option.date_max" type="date" label="Date de fermeture"></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field v-model="option.heure_max" type="time" label="Heure de fermeture"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field v-model="option.quantite" type="number" :disabled="is_quantite_disabled"
          label="Quantité max (0 si pas de limite)"></v-text-field>
      </v-col>
      <v-col cols="12" md="6" v-if="is_quantite_disabled">
        <v-alert border="start" border-color="red" density="compact">La modification de ce champ a des répercussions sur
          d'autres paramètres du module d'inscription. Veuillez contacter yann@sportips.fr</v-alert>
      </v-col>
    </v-row>

    <div v-if="majorations.length > 0">
      <v-divider class="my-3"></v-divider>
      <div class="text-h6 mb-3">Majorations tarifaires</div>
      <v-row v-for="(majoration, index_majoration) in majorations" :key="index_majoration">
        <v-col cols="12" md="2">
          <div>Majoration n°{{ index_majoration + 1 }}</div>
        </v-col>
        <v-col cols="12" md="5">
          <v-text-field v-model="majoration.date" type="date" label="Date de changement"></v-text-field>
        </v-col>
        <v-col cols="12" md="5">
          <v-text-field v-model="majoration.tarif" type="number" label="Prix"
            append-inner-icon="mdi-currency-eur"></v-text-field>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import Option from "@/classes/Options/Option.class";

export default {
  props: ["item"],
  data() {
    return {
      option: new Option(),
      majorations: [],
    };
  },
  computed: {
    is_quantite_disabled() {
      return !this.option.is_quantite_editable();
    },
  },
  watch: {
    majorations: {
      handler(val) {
        this.option.update_majorations(val);
      },
      deep: true,
    },
  },
  mounted() {
    this.option = this.item;
    this.majorations = this.option.get_majorations();
  },
};
</script>

<style lang="scss" scoped></style>
